export const isDevelopmentMode = process.env.NODE_ENV === "development";
// This flag just for comfortable hot reload that ignore unsaved changes on page
export const forceHotReload = process.env.FORCE_HOT_RELOAD === "true" && isDevelopmentMode;
